// @ts-nocheck

import { takeLatest, call, put } from 'redux-saga/effects';
import { router } from 'components/routes/Router';
import * as types from 'appRedux/actions/payment_act';
import {
  SHOW_FULLSCREEN_LOADER,
  HIDE_FULLSCREEN_LOADER,
} from 'appRedux/actions/loader';
import { API_URL as API_URI } from 'config/constants';
import * as services from 'utils/apiHelper';
import { successToast } from 'utils/toastHandler';
import getQueryParams from 'utils/getQueryParams';

function* getPaymentActRequest(action) {
  const token = localStorage.getItem('token');
  const { payload } = action;
  const query = getQueryParams(payload);
  const data = yield call(
    services.fetchGetApi,

    `${API_URI}/claim-payment-act/?${query}`,

    token,
  );

  if (data) {
    yield put({
      type: types.GET_PAYMENT_ACT_SUCCESS,
      payload: data,
    });
  }
}

function* addPaymentActRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPostApi,
    `${API_URI}/claim-payment-act/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: types.ADD_PAYMENT_ACT_SUCCESS,
      payload: data,
    });
    yield put({ type: types.CLOSE_FORM_MODAL });
    yield put({ type: types.RESET_FORM_FIELD });
    successToast('Payment Act Created Successfully');
  }
}

function* getPaymentActByIdRequest(action) {
  const token = localStorage.getItem('token');
  const {
    payload: { id },
  } = action;
  const data = yield call(
    services.fetchGetApi,

    `${API_URI}/claim-payment-act/${id}`,

    token,
  );

  if (data) {
    yield put({
      type: types.GET_PAYMENT_ACT_BY_ID_SUCCESS,
      payload: data,
    });
  }
}

function* updatePaymentActRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchPutApi,
    `${API_URI}/claim-payment-act/${payload.id}/`,
    payload,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({
      type: types.UPDATE_PAYMENT_ACT_SUCCESS,
    });
    yield put({ type: types.RESET_FORM_FIELD });
    router.navigate('/settings/claim-payment-act');
    successToast('Payment Act updated Successfully');
  }
}

function* deletePaymentActRequest(action) {
  yield put({ type: SHOW_FULLSCREEN_LOADER });
  const token = localStorage.getItem('token');
  const { payload } = action;

  const data = yield call(
    services.fetchDelApi,
    `${API_URI}/claim-payment-act/${payload.id}/`,
    token,
  );

  if (data) {
    yield put({ type: HIDE_FULLSCREEN_LOADER });
    yield put({ type: types.CLOSE_CONFIRMATION_MODAL });
    yield put({
      type: types.DELETE_PAYMENT_ACT_SUCCESS,
      payload,
    });
    successToast('Payment Act deleted Successfully');
  }
}

function* paymentActWatcher() {
  yield takeLatest(types.GET_PAYMENT_ACT_REQUEST, getPaymentActRequest);
  yield takeLatest(types.ADD_PAYMENT_ACT_REQUEST, addPaymentActRequest);
  yield takeLatest(
    types.GET_PAYMENT_ACT_BY_ID_REQUEST,
    getPaymentActByIdRequest,
  );
  yield takeLatest(types.UPDATE_PAYMENT_ACT_REQUEST, updatePaymentActRequest);
  yield takeLatest(types.DELETE_PAYMENT_ACT_REQUEST, deletePaymentActRequest);
}

export default paymentActWatcher;
